import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0303',
    ecrans: ['00-2']
});
